"use client";

import { NotificationProvider } from "./NotificationProvider";
import PresenceWrapper from "./PresenceWrapper";
import PushInitializer from "./PushInitializer";
import UserProviderClient from "./UserProviderClient";

export default function AuthProvider({ children }: { children: React.ReactNode }) {
    return (
        <UserProviderClient>
            <PresenceWrapper />
            <PushInitializer />
            <NotificationProvider>
                {children}
            </NotificationProvider>
        </UserProviderClient>
    );
}
